import TaskPanelContainer from '../TaskPanelContainer'
import EditTaskPanel from './EditTaskPanel'
import {PANEL_TYPES} from '../../constants'
import { AccessRights } from '../../../constants'

export default class EditTaskPanelContainer extends TaskPanelContainer {
    constructor(parameters = {
        scheduleCalculator: null,
        onPanelHide: () => {},
        onTaskDeletedCb: () => {},
        onTaskMovedCb: () => {},
        datePickerMenu: null,
        needToHideOnOutsideClick: true,
        needShowMoire: false,
    }) {
        super({
            ...parameters,
            additionalClass: 'edit_task_sliding_panel sliding_panel',
            panelContent: new EditTaskPanel({
                showComments: true,
                showReportTab: true,
                showActions: true,
                dateFormat: Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M"),
                datePickerMenu: parameters.datePickerMenu,
                onTaskDeletedCb: parameters.onTaskDeletedCb,
                onTaskMovedCb: parameters.onTaskMovedCb,
            }),
            panelType: PANEL_TYPES.EDIT_TASK,
            onPanelHideCb: () => parameters.onPanelHide(this.state.openTaskId),
        })

        this.state = {
            ...super.state,
            openTaskId: null,
            openTaskNextId: null,
            isOpenTaskCompleted: false,
            userRights: [],
            isTSTEnabled: false,
        }

        this.onStatePropertyChanged('openTaskNextId', () =>
            this.addTaskToTimesheet.setProps({ taskId: this.state.openTaskNextId })
        )

        this.onAnyStatePropertyChanged(['isOpenTaskCompleted', 'userRights', 'isTSTEnabled'], () => {
            const showAddToTimesheet = this.state.isTSTEnabled
                && !this.state.isOpenTaskCompleted
                && this.state.userRights[AccessRights.SUBMIT_TIME_TRACK]

            showAddToTimesheet
                ? this.$addTaskToTimesheet.show()
                : this.$addTaskToTimesheet.hide()
        })

    }

    afterRender() {
        super.afterRender()

        this.$addTaskToTimesheet = $('<div/>').addClass('addTaskToTimesheet_panelContainer atNextMount')
        this.$addTaskToTimesheet.appendTo(this.$headerButtons)

        this.addTaskToTimesheet = window.ClassicBridge.integrateAddTaskToTimesheetButton(
            this.$addTaskToTimesheet[0],
            {
                taskNextId: this.state.taskNextId
            }
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/editPanel/EditTaskPanelContainer.js